import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { Feature } from '@nirvana/shared/constants';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class SubmitToSandboxActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnCompanionRecords = false;
  protected canRunForMultipleItems = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE])) {
      return false;
    }

    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return false;
    }

    if (record.specifics.isManaged === false) {
      return false;
    }

    if (!ProtectedEntitiesHelper.isUnifiedClient(record)) {
      return false;
    }

    if (!record.specifics.operatingSystem) {
      return false;
    }

    if (!Constants.Tasks.SubmitToSandbox.SUPPORTED_OPERATING_SYSTEMS.includes(record.specifics.operatingSystem)) {
      return false;
    }

    return true;
  }
}
